<template lang="pug">
  .height-100
    transition(name='fade-quick')
      .overlay-class(
        v-if="mostrarModalImportarPlantillaEmpleado"
        :class="{'modal-sidebar-desktop-open': showSidebarDesktop }"
      )
        //- button.button.is-primary(@click="openModalImportarEmpleados") HOLLLL
        upload-image(
          name="name",
          folder="empleados",
          :is-saved="isSavedAdjunto"
          @close="closeAdjuntar"
          @save="procesoPlantilla"
        )
          span(slot="title") Plantilla de Empleados
          span(slot="explanation") Adjunta la plantilla de empleados
    //- .title
      span Mis solicitudes de permisos
      span.icon.close(
        @click="$emit('close')"
      )
        i.fa.fa-close

    //- h3.title Gestión de empleados
    //- p
    transition-group.contenedor-box-transition(name="fade-smooth-two", tag="div")
      .box.lista-solicitud-vacaciones.contenedor-interno.position-relative(key="box-lista")
        .title
          span Gestión de empleados
          span.icon.close(
            @click="$emit('close')"
          )
            i.fa.fa-close

        .body
          .filtros-container
            //- .title-filtros
              h2.text filtros
              .caret(@click="mostrarFiltros = !mostrarFiltros")
                span.icon
                  i.fa.fa-caret-down(v-if="mostrarFiltros")
                  i.fa.fa-caret-up(v-else)

            transition-group.contenedor-box-transition(name="fade-smooth-two", tag="div")
              .filtros(key="input-filtros" v-if="mostrarFiltros")
                .filtro
                  .codigo-empleado
                    .control.title-singular
                      p Codigo de empleado
                      .input-container
                        input.input(
                          type="number",
                          v-model="filtroCodigoEmpleado"
                        )
                        span.icon.cursor-pointer.margin-left-5(@click="mostrarBusquedaEmpleado = true")
                          i.fa.fa-search
                        .erase-data(@click="filtroCodigoEmpleado = ''")
                          .icon
                            .fa.fa-times
                    transition(name="fade-quick")
                      .pop-over(
                          v-if="mostrarBusquedaEmpleado"
                        )
                          lookup-small-empleado(
                            @selected="seleccionarEmpleado"
                            @close="mostrarBusquedaEmpleado = false"
                            :codigo="filtroCodigoEmpleado"
                            :empleadosInactivos="'all'"
                          )
                //- .filtro
                  .title-singular
                    p Urgencia
                  .status-container-filtro
                    .status(
                      v-for="o in filtrosUrgencia"
                      :class="{'selected': o === filtroUrgencia}"
                      @click="filtroUrgencia = o"
                    )
                      .circle(
                        :class="o"
                      )

              .boton-container(key="boton-filtro")
                button.button(@click="fetch")
                  span.icon.is-small
                    i.fa.fa-refresh.fa-fw.fa-lg
                  span Refrescar
                button.button(@click="limpiarFiltros")
                  span.icon.is-small
                    i.fa.fa-trash.fa-fw.fa-lg
                  span Limpiar
                button.button.is-primary(@click="nuevoEmpleado")
                  span.icon.is-small
                    i.fa.fa-plus.fa-fw.fa-lg
                  span Nuevo
                button.button.is-primary(@click="openModalImportarEmpleados")
                  span.icon.is-small
                    i.fa.fa-file-excel-o.fa-fw.fa-lg
                  span Excel
                button.button.is-primary(@click="descargarPlantillaEmpleados")
                  span.icon.is-small
                    i.fa.fa-download.fa-fw.fa-lg
                  span Descargar plantilla
          .information
            .is-desktop
              table.table.is-striped.is-bordered(v-show="lista.length !== 0")
                thead
                  th Empleado
                  th Fecha de Ingreso
                  th DNI
                  th Jefe
                  th
                transition-group.table-transition(
                  name="fade-smooth",
                  tag="tbody" v-show='lista.length !== 0',
                  v-infinite-scroll='fetchByScroll',
                  infinite-scroll-disabled='disabledScrollExcecute',
                  infinite-scroll-distance='2'
                  )
                  tr.row-table(
                    v-for="(o, index) in lista"
                    :key="`index_${index + 1}`"
                    :class="{'is-close': !o.activo}"
                  )
                    td
                      span {{ o.nombre }}
                      span.email  ({{ o.cargo }})
                      br
                      span.email {{ o.email }}
                      br
                      span(v-if="!o.activo && o.fechaInactivo").name.seen.has-text-bold Inactivo desde {{o.fechaInactivo}}
                    td
                      .wrapper
                        span {{ o.fechaIngreso }}
                        template(v-if="!o.contratoIndeterminado")
                          template(v-if="o.diasParaIndeterminado < 0")
                            span.has-text-bold Ya deberia ser indeterminado
                          template(v-else)
                            span.has-text-bold Indeterminado en:&nbsp
                            span {{ o.diasParaIndeterminado + ' días' }}
                    td {{ o.dni }}
                    td
                      span.hint--top(:aria-label="'Jefe: ' + o.dniJefe") {{ o.nombreJefe }}
                      br
                      span.email {{ o.emailJefe }}
                    td
                      .contenedor-acciones
                        button.button.is-small(v-if="o.activo" @click="openModalEditarEmpleado(o)")
                          span.icon.is-small
                            i.fa.fa-pencil-square-o
                          span Editar
                        button.button.is-small(v-else @click="openModalEditarEmpleado(o)")
                          span.icon.is-small
                            i.fa.fa-eye
                          span Ver
                        button.button.is-small.margin-left-5.is-danger(
                          v-if="o.activo"
                          @click="openModalDarBajaEmpleado(o)"
                        )
                          span.icon.is-small
                            i.fa.fa-thumbs-down
                          span Desactivar
            .is-mobile
              .box.has-text-left(
                v-for="(o, index) in lista"
                :key="index+'-mobile'"
                :class="{'is-close': !o.activo}"
              )
                .mt-10
                  span.name {{ o.nombre }}
                div
                  span.text-small DNI:&nbsp;
                  span {{ o.dni }}
                div
                  span.text-small Cargo:&nbsp;
                  span {{ o.cargo }}
                div
                  span.text-small Email:&nbsp;
                  span {{ o.email }}
                div
                  span.text-small Fecha de Ingreso:&nbsp;
                  span {{ o.fechaIngreso }}
                div(v-if="!o.contratoIndeterminado")
                  template(v-if="o.diasParaIndeterminado < 0")
                    span.has-text-bold Ya deberia ser indeterminado
                  template(v-else)
                    span.has-text-bold Indeterminado en:&nbsp;
                    span {{ o.diasParaIndeterminado + ' días' }}
                template(v-if="codigoLogueadoJefe !== (o.codigoJefe + '')")
                  div.hint--top(:aria-label="'Jefe: ' + o.dniJefe")
                    span.text-small Jefe:&nbsp;
                    span {{ o.nombreJefe }}
                  div
                    span.text-small Email jefe:&nbsp;
                    span {{ o.emailJefe }}
                .mt-5(v-if="!o.activo && o.fechaInactivo")
                  span.name.seen.has-text-bold Inactivo desde {{o.fechaInactivo}}
                .contenedor-acciones.mt-10
                    button.button.is-small(v-if="o.activo" @click="openModalEditarEmpleado(o)")
                      span.icon.is-small
                        i.fa.fa-pencil-square-o
                      span Editar
                    button.button.is-small(v-else @click="openModalEditarEmpleado(o)")
                      span.icon.is-small
                        i.fa.fa-eye
                      span Ver
                    button.button.is-small.margin-left-5.is-danger(
                      v-if="o.activo"
                      @click="openModalDarBajaEmpleado(o)"
                    )
                      span.icon.is-small
                        i.fa.fa-thumbs-down
                      span Desactivar
          .is-loading(v-show="isLoading")
            .icon
              i.fa.fa-spinner.fa-spin
            //- div(v-else)
              .message.is-warning
                .message-body No hay empleados que cumplan con los siguientes filtros
    transition(name='fade', v-if="mostrarModalDarDeBajaEmpleadoEmpleado")
      .modal(:class="{'is-active' : mostrarModalDarDeBajaEmpleadoEmpleado, 'modal-sidebar-desktop-open': showSidebarDesktop}")
        .modal-background
        .card(v-on-clickaway="closeModalDarBajaEmpleado")
          header.card-header
            p.card-header-title
              span Dar de baja empleado
            a.card-header-icon
              span.icon
                button.delete(@click="closeModalDarBajaEmpleado")
          .card-content
            .content
              span ¿ Esta seguro de dar baja al empleado
              strong &nbsp;{{codigoEmpleado}} - {{nombreEmpleado}}
              //- strong {{clienteHojaRutaSeleccionado}}
              span ?
          footer.card-footer
            button.button.card-footer-item.is-primary.is-outlined.info-box-button(
            @click="desactivarEmpleado()",
            :disabled="isLoading",
            :class="{'is-loading' : isLoading}")
              span Dar de baja
            button.button.card-footer-item.is-primary.is-outlined.info-box-button(
            @click="closeModalDarBajaEmpleado",
            :disabled="isLoading"
            ) Cancelar

    transition(name='fade', v-if="mostrarObservaciones")
      .modal(:class="{'is-active' : mostrarObservaciones}")
        .modal-background
        .card(v-on-clickaway="closeModalObservaciones")
          header.card-header
            p.card-header-title
              span Observaciones encontradas
            a.card-header-icon
              span.icon
                button.delete(@click="closeModalObservaciones")
          .card-content.card-content-observaciones-max-height
            .content.has-text-left
              div(v-if="observaciones.length > 0" v-for="o in observaciones")
                strong {{o}}
          footer.card-footer
            button.button.card-footer-item.is-primary.is-outlined.info-box-button(
            @click="closeModalObservaciones",
            :disabled="isLoading"
            ) Cancelar

    transition(name='fade', v-if="mostrarProcesandoPlantilla")
      .modal(:class="{'is-active' : mostrarProcesandoPlantilla}")
        .modal-background
        .card
          header.card-header
            p.card-header-title
              span Procesando
          .card-content
            .content
              strong {{mensajeProcesoPlantilla}}
          footer.card-footer
            button.button.card-footer-item.is-primary.is-outlined.info-box-button(
            :disabled="mostrarProcesandoPlantilla",
            :class="{'is-loading' : mostrarProcesandoPlantilla}")
              span


    editar-empleado(v-if="mostrarModalEditarEmpleado" @close="closeModalEditarEmpleado", :codigoEmpleado="codigoEmpleado")
    //- importar-plantilla-empleado(v-if="mostrarModalImportarPlantillaEmpleado", name="plantilla")
</template>

<script>
import LookupSmallEmpleado          from '@/components/Component_Lookup_Small_Empleado.vue'
import editarEmpleado               from '@/components/Component_Empleado_Editar.vue'
import UploadImageComponent         from '@/components/Component_Upload_Image'
import { mixin as clickaway }       from 'vue-clickaway';
import { apiGet, apiPost, apiGetExcel, notify }  from '../util/general'
export default {
  name: 'empleado-gestion',
  mixins: [ clickaway ],
  data () {
    return {
      lista                                 : [],
      listaFiltrada                         : [],
      codigoLogueadoJefe:localStorage.getItem('codigo') + '',
      isLoading                             : false,
      mostrarBusquedaEmpleado               : false,
      mostrarFiltros                        : true,
      mostrarConfirmacionNoLoTomo           : false,
      mostrarModalEditarEmpleado            : false,
      mostrarModalDarDeBajaEmpleadoEmpleado : false,
      mostrarModalImportarPlantillaEmpleado : false,
      mostrarObservaciones                  : false,
      mostrarProcesandoPlantilla            : false,
      disabledScrollExcecute                : false,
      noMore                                : false,
      isScroll                              : false,
      empleadoSeleccionado                  : {},
      filtroCodigoEmpleado                  : '',
      filtroUrgencia                        : 'white',
      codigoEmpleado                        : 0,
      nombreEmpleado                        : '',
      isSavedAdjunto                        : false,
      observaciones                         : [],
      numeroRecnum                          : 0,
      name                                  : 'plantilla_empleados',
      mensajeProcesoPlantilla               : '',
      filtrosUrgencia : [
        'white',
        'green',
        'yellow',
        'red'
      ]
    }
  },
  components: {
    LookupSmallEmpleado,
    editarEmpleado,
    'upload-image': UploadImageComponent
  },
  created () {
    this.limpiarFiltros()
    this.fetch()
  },
  watch : {
    filtroCodigoEmpleado (value) {
      return this.fetch()
    },
    filtroUrgencia (value) {
      return this.filtrarUrgencia()
    }
  },
  computed : {
    showSidebarDesktop () {
      return this.$store.getters.showSidebarDesktop
    }
  },
  methods: {
    fetch () {
      var vm                    = this
      vm.isLoading              = true
      vm.disabledScrollExcecute = true
      vm.noMore                 = false
      vm.listaFiltrada          = []

      if (!vm.isScroll) {
        vm.lista = []
        vm.numeroRecnum = 0
      }

      var filtros = {
        codigoEmpleado : vm.filtroCodigoEmpleado
      }

      var obj = {
        filtros: filtros,
        numeroRecnum : vm.numeroRecnum
      }

      apiGet(vm, '/empleado/obtener', obj, function (data) {
        vm.numeroRecnum = data.numeroRecnum
        for (var i = 0; i < data.lista.length; i++) {
          vm.lista.push(data.lista[i])
        }
        if (data.noMore) {
          vm.noMore = true
        } else {
          vm.disabledScrollExcecute = false
        }
      }, function (error) {
        notify(vm, 'error', 'Error', error.message)
      }, function () {
        vm.isScroll  = false
        vm.isLoading = false
      })
    },
    fetchByScroll () {
      this.isScroll = true
      this.fetch()
    },
    seleccionarEmpleado (o) {
      this.filtroCodigoEmpleado = o.codigo
    },
    limpiarFiltros () {
      this.filtroCodigoEmpleado = ''
      this.filtroUrgencia = 'white'
    },
    filtrarUrgencia () {
      var vm = this
      // Hacemos el filtro local
      if (vm.filtroUrgencia === 'white') {
        vm.listaFiltrada = vm.lista
      } else {
        if (vm.filtroUrgencia === 'green') {
          vm.listaFiltrada = vm.lista.filter(e => {
            return e.diasDisponibles < 35
          })
        } else if (vm.filtroUrgencia === 'yellow') {
          vm.listaFiltrada = vm.lista.filter(e => {
            return e.diasDisponibles >= 35 && e.diasDisponibles <= 40
          })
        } else if (vm.filtroUrgencia === 'red') {
          vm.listaFiltrada = vm.lista.filter(e => {
            return e.diasDisponibles > 40
          })
        }
      }
    },
    openModalEditarEmpleado (o) {
      var vm = this
      vm.mostrarModalEditarEmpleado = true
      vm.codigoEmpleado             = o.codigo
    },
    closeModalEditarEmpleado (o) {
      var vm = this
      vm.mostrarModalEditarEmpleado = false
    },
    desactivarEmpleado () {
      var vm = this
      vm.isLoading = true
      var obj = {
        codigo : vm.codigoEmpleado
      }
      apiPost(vm, '/empleado/baja', obj, function (data) {
        notify(vm, 'success', 'Éxito', 'Se dio de baja correctamente')
        vm.closeModalDarBajaEmpleado()
        vm.fetch()
      }, function (error) {
        notify(vm, 'error', 'Error', error.message)
      }, function () {
        vm.isLoading = false
      })
    },
    nuevoEmpleado () {
      var vm = this
      vm.codigoEmpleado             = 0
      vm.mostrarModalEditarEmpleado = true
    },
    openModalDarBajaEmpleado (o) {
      var vm = this
      vm.codigoEmpleado                         = o.codigo
      vm.nombreEmpleado                         = o.nombre
      vm.mostrarModalDarDeBajaEmpleadoEmpleado = true
    },
    closeModalDarBajaEmpleado () {
      var vm = this
      vm.codigoEmpleado                         = 0
      vm.nombreEmpleado                         = ''
      vm.mostrarModalDarDeBajaEmpleadoEmpleado = false
    },
    closeModalObservaciones () {
      var vm = this
      vm.observaciones        = []
      vm.mostrarObservaciones = false
    },
    openModalImportarEmpleados () {
      var vm = this
      vm.mostrarModalImportarPlantillaEmpleado = true
    },
    descargarPlantillaEmpleados () {
      var vm = this
      var url = 'empleado/plantilla/excel'
      var obj = {
      }
      apiGetExcel(vm, url, obj, function (data) {
        var a = document.createElement('a');
        a.style = 'display: none';
        document.body.appendChild(a);

        var blob = new Blob([data], {type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;base64,'})
        var url = window.URL.createObjectURL(blob)

        a.href = url;
        a.download = vm.name + '_' + ((new Date()).getTime()) + '.xlsx';
        a.click();
        window.URL.revokeObjectURL(url);

        // window.open(url);
      }, function (error) {
        console.error('Error:' + error.message)
      }, function () {
      })
    },
    closeAdjuntar () {
      this.mostrarModalImportarPlantillaEmpleado   = false
    },
    validarArchivoExcel (fileSubido, callback) {
      var vm = this
      var obj = {
        fileSubido: fileSubido
      }

      // return
      apiPost(vm, '/empleado/validar/plantilla/excel', obj, function (data) {
        callback(null, data.observaciones)
      }, function (err) {
        callback(err)
      })
    },
    guardarArchivoExcel (fileSubido, callback) {
      var vm = this
      var obj = {
        fileSubido: fileSubido
      }

      // return
      apiPost(vm, '/empleado/guardar/plantilla/excel', obj, function (data) {
        callback(null)
      }, function (err) {
        callback(err)
      })
    },
    procesoPlantilla (fileSubido) {
      var vm = this
      vm.observaciones = []
      vm.mostrarModalImportarPlantillaEmpleado = false
      vm.mostrarProcesandoPlantilla = true
      vm.mensajeProcesoPlantilla = 'Validando datos...'
      vm.validarArchivoExcel(fileSubido.file.localPath, function (err, observaciones) {
        if (err) {
          vm.mostrarProcesandoPlantilla = false
          notify(vm, 'error', 'Error', err.message)
        } else {
          if (observaciones.length > 0) {
            vm.observaciones                         = observaciones
            // vm.mostrarModalImportarPlantillaEmpleado = false
            vm.mostrarObservaciones                  = true
            vm.mostrarProcesandoPlantilla            = false
          } else {
            vm.mensajeProcesoPlantilla = 'Guardando plantilla...'
            vm.guardarArchivoExcel(fileSubido.file.localPath, function (err) {
              if (err) {
                vm.mostrarProcesandoPlantilla  = false
                notify(vm, 'error', 'Error', err.message)
              } else {
                notify(vm, 'success', 'Éxito', 'Se proceso correctame el archivo excel.')
                // vm.mostrarModalImportarPlantillaEmpleado = false
                vm.mostrarProcesandoPlantilla            = false
                vm.fetch()
              }
            })
          }
        }
      })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="stylus" scoped>
  .wrapper
    display flex
    justify-content left
    align-items left
    flex-direction column
  .seen
    background-color: #DA8D7D;
    padding: 0px 4px;
    margin-top: 3px;
    border-radius: 4px;
    color: #fff;
  .contenedor-interno
    .close
      position absolute
      top 3px
      right 3px
      float right
      cursor pointer
      i
        font-size 16px

    .title
      font-size 16px
      span
        font-weight bold
        text-transform uppercase
  .contenedor-acciones
    display flex
    justify-content space-around
    .button
      flex 1
      margin 0px 5px
  th
    text-align center

  .row-table
    transition all 0.3s ease
    &.is-close
      background-color #ffd6d6 !important

  .is-close
    background-color: #ffd6d6 !important;

  .table-row-enter, .table-row-leave-active {
    opacity: 0
    height 0
  }

  .pop-over
    background: #fff;
    border-radius: 3px;
    border: 1px solid #d6dadc;
    border-bottom-color: #c4c9cc;
    -webkit-box-shadow: 0 1px 6px rgba(0,0,0,.15);
    box-shadow: 0 1px 6px rgba(0,0,0,.15);
    position: absolute;
    min-width: 300px
    width: 100%;
    z-index: 70;
    top 0

  .position-relative
    position relative

  .codigo-empleado
    position relative
    .control
      .input-container
        display flex
        align-items center
        .input
          flex 1
          width 100px
        .erase-data
          cursor pointer
          margin-left 5px

  .filtros-container
    padding-bottom 10px
    border-bottom 1px solid #ccc
    .title-filtro
      display flex
      text-align left
      padding-left 10px
      padding-bottom 10px
      margin-bottom 10px
      border-bottom 1px solid #ccc
      .text
        text-transform uppercase
        flex 1
      .caret
        cursor pointer

    .filtros
      margin-bottom 10px
      text-align left
      display flex
      align-items: flex-start;


      .filtro
        display inline-block
        border 1px solid #cccccc
        background-color #f9f9f9
        padding 5px
        margin 5px
        border-radius 3px
        flex 1
        max-width 20rem
        .title-singular
          text-align left
          font-weight bold
          user-select: none
        .abierto-cerrado-container
          display flex
          .option
            padding 4px
            border 1px solid #565cde
            color #565cde
            cursor pointer
            transition all 0.3s ease
            height 31.5px

            &.selected
              background-color: #565cde;
              color: #fff;

        .list-container
          padding 0px 10px 0px 10px
          .option
            user-select: none
            cursor pointer
            &.selected
              color #565cde
              font-weight bold

  .boton-container
    button
      margin-left 5px
      margin-top 5px



  .is-loading
    margin-top 10px

  .button.is-loading
    margin-top 0px

  .information
    padding-top 10px

  th
    vertical-align: middle;
  td
    vertical-align: middle;

  td
    .email
      font-size 12px
      color #9a9a9a

  .table
    font-size 13px

  .td-status
    width: 50px;

  .status
    align-items: center;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    .circle
      width: 25px;
      height: 25px;
      border-radius: 50%
      transition background ease-in .15s
      border 1px solid #d8d8d8
      background-color #23d160
      &.green
        background-color #23d160
      &.yellow
        background-color #ffdd57
      &.red
        background-color #ff0000
      &.white
        background-color #ffffff

  .status-container-filtro
    display flex
    justify-content center
    align-items center
    .status
      margin 5px
      cursor pointer
      .circle
        transition all ease-in .15s
        width: 30px;
        height: 30px;
      &.selected
        .circle
          border 2px solid #565cde
  .card-footer-item:not(:last-child)
    border-right: 1px solid #dbdbdb
  .info-box-button
    border-radius 0
    border        0px

  .card-content-observaciones-max-height
    max-height: calc(100vh - 300px);
    overflow: auto;
  .is-mobile
    display none
  .text-small
    font-size 12px
    color #9a9a9a

  .modal-sidebar-desktop-open
    width: calc(100% - 180px);
  @media screen and (max-width: 950px)
    .is-desktop
      display none
    .is-mobile
      display block

    .name
      font-size: 16px;
  @media (max-width: 820px)
    .modal-sidebar-desktop-open
      width: 100%;

</style>




// WEBPACK FOOTER //
// View_Gestion_Empleado.vue?6e9046be